import { QueryFactory } from "../../../../Common";
export const QCalculateBets = QueryFactory("CalculateBets");
//# sourceMappingURL=QCalculateBets.js.map